// Phase 2.7 — REST-backed memorizationSuggestions service.
//
// upsertSuggestion / listPendingSuggestionsForStudent / listPendingSuggestionsForTenant /
// approveSuggestion / dismissSuggestion all map to /api/memorization-suggestions
// endpoints. Pure helpers (toPortionId, suggestionDocId, detection)
// stay in the legacy module.

import { getAccessToken } from '../contexts/AuthContextV2';

const API_BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:4001';

async function apiFetch(path, options = {}) {
  const token = getAccessToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers, credentials: 'include' });
  let body = null;
  try { body = await res.json(); } catch { /* non-json */ }
  if (!res.ok) {
    const err = new Error(body?.error || `Request failed: ${res.status}`);
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function upsertSuggestion({ tenantId, studentId, classId, detection }) {
  if (!tenantId) throw new Error('tenantId is required');
  if (!studentId) throw new Error('studentId is required');
  if (!detection || !detection.portionId) throw new Error('detection.portionId is required');
  const { suggestion } = await apiFetch('/api/memorization-suggestions', {
    method: 'POST',
    body: JSON.stringify({
      studentId,
      classId: classId || null,
      portionId: detection.portionId,
      hizb: detection.hizb,
      rubuu: detection.rubuu,
      evidence: detection.evidence,
      avgHifz: detection.avgHifz,
      avgTajweed: detection.avgTajweed,
      passCount: detection.passCount
    })
  });
  return { id: suggestion.id, suggestion };
}

export async function listPendingSuggestionsForStudent(studentId) {
  if (!studentId) return [];
  try {
    const { suggestions } = await apiFetch(
      `/api/memorization-suggestions?status=pending&studentId=${encodeURIComponent(studentId)}`
    );
    return suggestions;
  } catch (err) {
    console.warn('listPendingSuggestionsForStudentV2 failed:', err.message);
    return [];
  }
}

export async function listPendingSuggestionsForTenant(_tenantId) {
  // tenantId comes from JWT server-side.
  try {
    const { suggestions } = await apiFetch('/api/memorization-suggestions?status=pending');
    return suggestions;
  } catch (err) {
    console.warn('listPendingSuggestionsForTenantV2 failed:', err.message);
    return [];
  }
}

export async function approveSuggestion({ suggestionId }) {
  if (!suggestionId) throw new Error('suggestionId is required');
  await apiFetch(`/api/memorization-suggestions/${encodeURIComponent(suggestionId)}/approve`, {
    method: 'POST'
  });
}

export async function dismissSuggestion(suggestionId, reason = null) {
  if (!suggestionId) throw new Error('suggestionId is required');
  await apiFetch(`/api/memorization-suggestions/${encodeURIComponent(suggestionId)}/dismiss`, {
    method: 'POST',
    body: JSON.stringify({ reason })
  });
}
